import type { AccountErasure } from '../../api/account';
export function hasErasureReceipt(): boolean {
  try { return !!(JSON.parse(sessionStorage.getItem('steos:erasure:operation') || 'null') as AccountErasure | null)?.status_receipt; }
  catch { return false; }
}
